module.exports = __webpack_public_path__ + "static/media/PaymentOnboardingFailed.8c425e0b.svg";